import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtilsService } from "../_base/crud";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class ConfigLogisticService {
  private API_LOGISTICCONFIGURATION_URL = environment.API_URL + "api/logisticonfiguration/";

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {}

  getList(): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    return this.http.get(this.API_LOGISTICCONFIGURATION_URL + "list", { headers: httpHeaders });
  }

  getLogisticConfig(value: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    return this.http.get(this.API_LOGISTICCONFIGURATION_URL + value.id, { headers: httpHeaders });
  }

  createLogisticConfig(value: any) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    return this.http.post(this.API_LOGISTICCONFIGURATION_URL, value, { headers: httpHeaders });
  }

  updateLogisticConfig(value: any) {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    return this.http.put(this.API_LOGISTICCONFIGURATION_URL + value.id, value, { headers: httpHeaders });
  }
}
